import resolvePromise from '../helper/resolved_promise';
import { FilterActions } from '../constants/filter/filter_actions';
import Dispatcher from '../dispatcher';

function showFiltersAction(fromPreviousView) {
    Dispatcher.handleCatalogFilterViewAction({ type: FilterActions.SHOW_FILTER });

    if (!fromPreviousView) {
        document.body.style.overflow = 'hidden';
    }

    return resolvePromise();
}

function hideFiltersAction() {
    Dispatcher.handleCatalogFilterViewAction({ type: FilterActions.HIDE_FILTER });
    document.body.style.overflow = '';
    return resolvePromise();
}

function showSectionContentsAction(payload) {
    Dispatcher.handleCatalogFilterViewAction({ type: FilterActions.SHOW_FILTER_SECTION, payload });

    return resolvePromise();
}

function hideSectionContentsAction(payload) {
    Dispatcher.handleCatalogFilterViewAction({ type: FilterActions.HIDE_FILTER_SECTION, payload });

    return resolvePromise();
}

export {
    showFiltersAction,
    hideFiltersAction,
    showSectionContentsAction,
    hideSectionContentsAction
};